import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I2gNgTrackingModule } from 'i2g-ng-tracking';
import { SharedModule } from '../shared/shared.module';
import { GlobalHeaderV2Component } from './components/global-header-v2/global-header-v2.component';
import { NotificationsModule } from '../notifications/notifications.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    I2gNgTrackingModule,
    NotificationsModule,
  ],
  declarations: [GlobalHeaderV2Component],
  exports: [GlobalHeaderV2Component],
})
export class GlobalHeaderV2Module {}
